import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IResourceItem } from "@common/interfaces/resourceItem";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";

export interface ResourceItemState extends EntityState<IResourceItem, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.RESOURCE_ITEMS , realtimeEntity: 'ResourceItem'})
export class ResourceItemStore extends EntityStore<ResourceItemState> {

  constructor() {
    super([]);
  }

}
